export default __webpack_public_path__ + "static/media/Eater-Regular.747fd103.ttf";